/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSettingsAPI = /* GraphQL */ `
  mutation CreateSettingsAPI(
    $input: CreateSettingsAPIInput!
    $condition: ModelSettingsAPIConditionInput
  ) {
    createSettingsAPI(input: $input, condition: $condition) {
      id
      username
      email
      phone_number
      sub
      user
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSettingsAPI = /* GraphQL */ `
  mutation UpdateSettingsAPI(
    $input: UpdateSettingsAPIInput!
    $condition: ModelSettingsAPIConditionInput
  ) {
    updateSettingsAPI(input: $input, condition: $condition) {
      id
      username
      email
      phone_number
      sub
      user
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSettingsAPI = /* GraphQL */ `
  mutation DeleteSettingsAPI(
    $input: DeleteSettingsAPIInput!
    $condition: ModelSettingsAPIConditionInput
  ) {
    deleteSettingsAPI(input: $input, condition: $condition) {
      id
      username
      email
      phone_number
      sub
      user
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
